import { useMutation } from '@tanstack/react-query';
import { patchSubsidyById } from '../../../../api/subsidy/mutations/patchSubsidyById';

export const usePatchSubsidyByIdMutation = () => {
  return useMutation(patchSubsidyById);
};
